import NoMatch from './NoMatch.view';

export default NoMatch;
